import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../lib/firebase";

// Get the version document
export async function getVersionDoc() {
  try {
    const ref = doc(db, "meta", "version");
    const snap = await getDoc(ref);
    return snap.exists() ? snap.data() : null;
  } catch {
    return null;
  }
}

// Get versions for all collections
export async function getCollectionVersions() {
  const versionDoc = await getVersionDoc();
  return versionDoc?.collections || {};
}

// Update version for a specific collection after save/delete
export async function updateCollectionVersion(collectionName) {
  try {
    const ref = doc(db, "meta", "version");
    await setDoc(
      ref,
      {
        collections: {
          [collectionName]: new Date().toISOString(),
        },
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );
  } catch {
    // Silent fail — version update is optional
  }
}

// Initialize version document with all collections
export async function initVersionDoc(collections) {
  try {
    const ref = doc(db, "meta", "version");
    const now = new Date().toISOString();
    const versions = {};
    collections.forEach((c) => {
      versions[c] = now;
    });
    await setDoc(
      ref,
      {
        collections: versions,
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );
  } catch {
    // Silent fail
  }
}
